module.exports = __webpack_public_path__ + "img/admin.33809f49.png";